export enum RouteName {
  SEARCH_ITEM = 'searchItem',
  CUTTER = 'cutter',
  SOURCE_BROWSER = 'sourceBrowser',
  SEQUENCE_PROPERTIES = 'sequenceProperties',
  CONTROL_POINT_EDITOR = 'controlPointEditor',
  BOX_PROPERTIES = 'boxProperties',
  ITEM_PROPERTIES = 'itemProperties',
  SHARE = 'share',
  USER_TASKS = 'userTasks',
  ACTIVITY = 'activity',
  SCHEDULER = 'scheduler',
  PLAYOUT = 'playout',
  PREMIERE = 'premiere',
  SETTINGS = 'settings',
  MY_ORGANIZATION = 'myOrganization',
  CHANGELOG = 'changelog',
  USER_SETTINGS = 'userSettings',
  DESKTOP_SETTINGS = 'desktopSettings',
  AME_SETTINGS = 'ameSettings',
  DVR_SETTINGS = 'dvrSettings',
  LOGGING_SETTINGS = 'loggingSettings',
  ITEM_DETAILS = 'itemDetails',
  PERSON_DETAILS = 'personDetails',
  ADMIN = 'admin',
  ADMIN_SYSTEM_TASKS = 'adminSystemTasks',
  SSO_CONFIGURATION = 'ssoConfiguration',
  ADMIN_SYSTEM_TASKS_START = 'adminSystemTasksStart',
  SUPPORT = 'support',
  FOLDER_VIEW = 'folderView',
  RECYCLE_BIN = 'recycleBin',
  CHANGE_PASSWORD = 'changePassword',
  EXPORT = 'export',
  BROWSE = 'browse',
  MOS = 'mos',
  DRAG = 'drag',
  FRAME_DRAG = 'framedrag',
  PUBLIC = 'public',
  FORGOT_PASSWORD = 'forgotPassword',
  FORGOT_PASSWORD_VERIFY = 'forgotPasswordVerify',
  FORGOT_PASSWORD_RESET = 'forgotPasswordReset',
  BARE_DEV = 'bareDev',
  SIGN_IN_CODE = 'signInCode',
}
